export const ContactStyles = {
  root: {
    minHeight: '111.11vh',
    background: 'linear-gradient(to bottom, rgb(227, 248, 255), rgb(120, 162, 240))',
    padding: 0,
  },
  headerSection: {
    background: '#231f1e',
    color: '#fff',
    padding: { xs: '60px 20px', md: '80px 40px' },
    textAlign: 'center',
  },
  title: {
    fontSize: { xs: '2.5rem', md: '3.5rem' },
    fontWeight: 700,
    color: '#b3c6e7',
    fontFamily: '"Higuen Serif", serif',
    marginBottom: 2,
    letterSpacing: 2,
  },
  subtitle: {
    fontSize: { xs: '1.1rem', md: '1.3rem' },
    color: '#e0d7ce',
    maxWidth: '800px',
    margin: '0 auto',
    lineHeight: 1.6,
  },
  mainContent: {
    padding: { xs: '40px 20px', md: '60px 40px' },
    maxWidth: '1200px',
    margin: '0 auto',
  },
  formPaper: {
    padding: { xs: '30px', md: '40px' },
    borderRadius: '20px',
    background: '#fff',
    boxShadow: '0 4px 32px 0 rgba(44, 26, 126, 0.08)',
    border: '2px solid #e3f8ff',
  },
  formTitle: {
    fontSize: '2rem',
    fontWeight: 600,
    color: '#231f1e',
    fontFamily: '"Higuen Serif", serif',
    marginBottom: 3,
    textAlign: 'center',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      '& fieldset': {
        borderColor: '#b3c6e7',
        borderWidth: 2,
      },
      '&:hover fieldset': {
        borderColor: '#6ec6ff',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
    '& .MuiInputLabel-root': {
      color: '#231f1e',
      fontWeight: 500,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#1976d2',
    },
  },
  submitButton: {
    background: '#ffa726',
    color: '#231f1e',
    fontWeight: 600,
    fontSize: '1.1rem',
    borderRadius: '30px',
    padding: '14px 36px',
    textTransform: 'none',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    '&:hover': {
      background: '#fb8c00',
      color: '#fff',
    },
    '&:disabled': {
      background: '#ccc',
      color: '#666',
    },
  },
  infoSection: {
    padding: { xs: '20px', md: '0' },
  },
  infoTitle: {
    fontSize: '2rem',
    fontWeight: 600,
    color: '#231f1e',
    fontFamily: '"Higuen Serif", serif',
    marginBottom: 1,
  },
  infoSubtitle: {
    fontSize: '1.1rem',
    color: '#231f1e',
    marginBottom: 3,
    lineHeight: 1.6,
    opacity: 0.8,
  },
  infoCard: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 3,
    padding: '20px',
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 2px 12px 0 rgba(44, 26, 126, 0.08)',
    border: '2px solid #e3f8ff',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 20px 0 rgba(44, 26, 126, 0.12)',
    },
  },
  infoIcon: {
    marginRight: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '60px',
  },
  infoContent: {
    flex: 1,
  },
  infoCardTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#231f1e',
    marginBottom: 0.5,
  },
  infoCardDetails: {
    fontSize: '1rem',
    fontWeight: 500,
    color: '#1976d2',
    marginBottom: 0.5,
  },
  infoCardDescription: {
    fontSize: '0.9rem',
    color: '#231f1e',
    opacity: 0.7,
    lineHeight: 1.4,
  },
  faqSection: {
    padding: '40px',
    background: '#f7f9fb',
    borderRadius: '16px',
    border: '2px solid #e3f8ff',
    minHeight: '500px',
    display: 'flex',
    flexDirection: 'column',
  },
  faqTitle: {
    fontSize: '2rem',
    fontWeight: 600,
    color: '#231f1e',
    fontFamily: '"Higuen Serif", serif',
    marginBottom: 3,
    textAlign: 'center',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60px',
      height: '3px',
      background: 'linear-gradient(90deg, #ffa726, #1976d2)',
      borderRadius: '2px',
    },
  },
  faqItem: {
    marginBottom: 2.5,
    padding: '20px',
    background: '#fff',
    borderRadius: '12px',
    border: '1px solid #e3f8ff',
    boxShadow: '0 2px 8px rgba(44, 26, 126, 0.06)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 16px rgba(44, 26, 126, 0.12)',
      borderColor: '#b3c6e7',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  faqQuestion: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: '#231f1e',
    marginBottom: 1,
    display: 'flex',
    alignItems: 'center',
    '&::before': {
      content: '"Q"',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      height: '24px',
      background: 'linear-gradient(135deg, #ffa726, #fb8c00)',
      color: '#fff',
      borderRadius: '50%',
      fontSize: '0.8rem',
      fontWeight: 700,
      marginRight: '12px',
      flexShrink: 0,
    },
  },
  faqAnswer: {
    fontSize: '1rem',
    color: '#231f1e',
    opacity: 0.8,
    lineHeight: 1.6,
    paddingLeft: '36px',
    position: 'relative',
    '&::before': {
      content: '"A"',
      position: 'absolute',
      left: '0',
      top: '0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      height: '24px',
      background: 'linear-gradient(135deg, #1976d2, #1565c0)',
      color: '#fff',
      borderRadius: '50%',
      fontSize: '0.8rem',
      fontWeight: 700,
    },
  },
  faqItemsContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
};
